<app-page-header></app-page-header>

<div class="content">
  <router-outlet></router-outlet>
</div>
<app-page-bottom></app-page-bottom>

<!-- <img
  *ngIf="!router.url.startsWith('/login')"
  src="../../../assets/images/customer_service.png"
  width="80px"
  height="80px"
  class="service"
  matRipple
  (click)="showCustomerService()"
/> -->
